const PUBLIC_ROUTES = ['/', '/home', '/news', '/fixtures']

let tealiumInjectQueued = false

function maybeQueueTealiumInject(store) {
  if (tealiumInjectQueued) return
  if (!store.state.brandConfig?.brand?.includes('vc')) return
  tealiumInjectQueued = true
  const schedule = window.requestIdleCallback || ((cb) => setTimeout(cb, 2500))
  schedule(async () => {
    try {
      const { injectScript } = await import('@/services/tealium')
      await injectScript()
    } catch (e) {
      // Analytics failure must not affect navigation.
    }
  })
}

export default async function userAuthenticate(to, from, next, store) {
  maybeQueueTealiumInject(store)

  // Handle e-msisdn login from URL params (e.g. redirect from voucher store)
  const eMsisdn = to.query?.['e-msisdn']
  if (eMsisdn) {
    try {
      const result = await store.dispatch('loginWithEmsisdn', eMsisdn)
      const cleanQuery = { ...to.query }
      delete cleanQuery['e-msisdn']
      const cleanRoute = {
        path: to.path,
        query: Object.keys(cleanQuery).length ? cleanQuery : undefined,
        replace: true
      }
      // Always remove e-msisdn from URL (on success or failure)
      return next(cleanRoute)
    } catch (err) {
      console.error('e-msisdn login failed:', err)
      const cleanQuery = { ...to.query }
      delete cleanQuery['e-msisdn']
      return next({
        path: to.path,
        query: Object.keys(cleanQuery).length ? cleanQuery : undefined,
        replace: true
      })
    }
  }

  const msisdn = localStorage.getItem('msisdn')
  const sessionId = localStorage.getItem('sessionId')
  const isPublicRoute = PUBLIC_ROUTES.includes(to.path)
  const requiresAuth = to.meta?.requiresAuth === true

  if (!sessionId || !msisdn) {
    if (requiresAuth) {
      store.commit('setIntendedPath', to.fullPath)
      store.commit('setShowLoginModal', true)
      store.commit('setError', null)
      return next(false)
    }
    return isPublicRoute ? next() : next('/home')
  }

  if (!store.state.user) {
    try {
      store.commit('setMsisdn', msisdn)
      store.commit('setSessionId', sessionId)

      const user = await store.dispatch('fetchAndSetUser', { force: false })

      if (!user) {
        await store.dispatch('clearSession')
        return next('/home')
      }
    } catch (error) {
      console.error('Authentication error:', error)
      await store.dispatch('clearSession')
      return next('/home')
    }
  }

  if (to.meta?.requiresSubscription && !store.getters.isSubscribed) {
    if (!sessionId) {
      store.commit('setPendingAction', () => store.commit('setShowSubscribeModal', true))
      store.commit('setShowLoginModal', true)
      store.commit('setError', null)
    } else {
      store.commit('setShowSubscribeModal', true)
    }
    return next(false)
  }

  next()
}
